import BookingDetailView from './BookingDetail';

export default BookingDetailView;
